import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-[#efe7da] px-5 py-14" data-id="element-111" data-mp="1o46jikin3mvk">
      <div className="mx-auto max-w-md" data-id="element-112" data-mp="1o5q1qgnuw7zz">
        <div className="rounded-3xl border-2 border-[#d8c19a] bg-white p-6 text-center shadow-sm" data-id="element-113" data-mp="223y4543nw1ij">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#d8c19a]/20" data-id="element-114" data-mp="1x3tp7iiejeuf">
            <ShieldCheckIcon className="w-8 h-8 text-[#b99a63]" data-id="element-115" data-mp="19dzdx5dqdyca" />
          </span>
          <h2 className="mt-4 font-serif-display text-2xl font-bold text-[#3b3350]" data-id="element-116" data-mp="14fxps61g78ty">
            Garantía de Satisfacción de 30 Días
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-[#5a5266]" data-id="element-117" data-mp="1j6554cw5sbqf">
            Prueba la Biblioteca sin ningún riesgo. Si en los próximos 30 días sientes que no
            era lo que esperabas, solo escríbenos y te devolveremos el 100% de tu dinero.
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-1 text-xs font-semibold text-[#7c6aa8]" data-id="element-118" data-mp="lpy7c2044rzi">
            <span data-id="element-119" data-mp="oyqewbuo01kq">Sin preguntas</span>
            <span data-id="element-120" data-mp="oxp0bxefwwy9">·</span>
            <span data-id="element-121" data-mp="ty2z0ou5iujm">Sin complicaciones</span>
            <span data-id="element-122" data-mp="tx1oqmkymc2y">·</span>
            <span data-id="element-123" data-mp="tw9q12w2fy8g">Sin letra pequeña</span>
          </div>
        </div>
      </div>
    </section>;
}